import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { ReportOptionsModule } from './report-options/report-options.module';
import { ReportHeaderComponent } from './report-header/report-header.component';
import { ReportProgressComponent } from './report-progress/report-progress.component';
import { ReportViewButtonComponent } from './report-view-button/report-view-button.component';
import { ReportAnalysisIconComponent } from './report-analysis-icon/report-analysis-icon.component';
import { ReportDialogFooterComponent } from './report-dialog-footer/report-dialog-footer.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReportTableComponent } from './report-table/report-table.component';
import { ReportExportToComponent } from './report-export-to/report-export-to.component';
import { ChangeViewButtonComponent } from './change-view-button/change-view-button.component';
import { ReportTableHeaderComponent } from './report-table-header/report-table-header.component';
import { ReportNameComponent } from './report-name/report-name.component';

const sharedComponents = [
  ReportHeaderComponent,
  ReportProgressComponent,
  ReportViewButtonComponent,
  ReportAnalysisIconComponent,
  ReportDialogFooterComponent,
  ReportTableComponent,
  ReportExportToComponent,
  ChangeViewButtonComponent,
  ReportTableHeaderComponent,
  ReportNameComponent,
];

@NgModule({
  imports: [
    SharedModule,
    TranslateModule.forChild(),
    CommonModule,
    ReportOptionsModule,
  ],
  declarations: [...sharedComponents],
  exports: [ReportOptionsModule, ...sharedComponents, SharedModule],
})
export class ReportSharedModule {}
